import { ButtonBase, type ButtonBaseProps } from "@mui/material";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { CbhIcon, type IconType } from "../CbhIcon";
import { Text } from "../Text";

export interface CalloutProps extends Omit<ButtonBaseProps, "title"> {
  title: string | React.ReactNode;
  iconType: IconType;
}

export function Callout(props: CalloutProps) {
  const { title, iconType, sx, ...restProps } = props;

  return (
    <ButtonBase
      sx={mergeSxProps(
        (theme) => ({
          backgroundColor: theme.palette.intent?.neutral.background,
          color: theme.palette.intent?.neutral.text,
          borderRadius: theme.borderRadius?.xLarge,
          py: 3,
          px: 4,
          gap: 3,
          userSelect: "none",
          alignItems: "center",
          justifyContent: "flex-start",

          "& svg": {
            flexShrink: 0,
          },

          "& .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        }),
        sx
      )}
      {...restProps}
    >
      <CbhIcon type={iconType} size="small" />

      <Text semibold variant="body2" sx={{ flexShrink: 0, color: "inherit" }}>
        {title}
      </Text>
    </ButtonBase>
  );
}
